<template>
  <div>
    <div class="animates-items mb16">
      <cx-border
        :borderWidth.sync="borderWidth"
        :borderStyle.sync="borderStyle"
        :borderColor.sync="borderColor"
        :borderIsThemeColor.sync="borderIsThemeColor"
      />
    </div>
    <div class="animates-items">
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDuration"
        title="持续"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <slider-and-input
        class="mb16"
        inputWidth="small"
        inputHeight="small"
        :value.sync="animateDataVal.animateDelay"
        title="延迟"
        titlePosition="allInOneLine"
        :sliderMax="10000"
        suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
              v-for="(option, index) in triggerstyles.list"
              :key="index"
              :label="option.value"
              :disabled="option.disabled"
              >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "border-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    },
    options: {
      type: Object
    }
  },
  data() {
    return {
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    },
    borderVariable: {
      get() {
        let defaultBorder
        if (!this.animateDataVal.border || JSON.stringify(this.animateDataVal.border) === "{}") {
          let options = JSON.parse(JSON.stringify(this.options))
          // defaultBorder = {
          //   borderWidth: options.borderWidth,
          //   borderColor: options.borderColor,
          //   borderStyle: options.borderStyle,
          //   borderIsThemeColor: options.borderIsThemeColor || false
          // }
          // 不取当前组件的值，因为可能会控制的是多个组件，不清楚取哪一个合适
          defaultBorder = {
            borderWidth: 0,
            borderColor: "rgba(0,0,0,1)",
            borderStyle: "solid",
            borderIsThemeColor: false
          }
          this.animateDataVal.border = defaultBorder
        }
        return this.animateDataVal.border
      },
      set(newVal) {
        // this.getBorderStyle(newVal)
      }
    },
    borderWidth: {
      get() {
        return this.borderVariable.borderWidth
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderWidth", newVal)
        // this.getBorderStyle()
      }
    },
    borderColor: {
      get() {
        return this.borderVariable.borderColor
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderColor", newVal)
        // this.getBorderStyle()
      }
    },
    borderStyle: {
      get() {
        return this.borderVariable.borderStyle
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderStyle", newVal)
        // this.getBorderStyle()
      }
    },
    borderIsThemeColor: {
      get() {
        return this.borderVariable.borderIsThemeColor
      },
      set(newVal) {
        this.$set(this.borderVariable, "borderIsThemeColor", newVal)
        // this.getBorderStyle()
      }
    }
  },
  mounted() {},
  methods: {
    getBorderStyle() {
      let curBorder = this.borderVariable
      let borderW = curBorder.borderWidth
      if (!Array.isArray(curBorder.borderWidth)) {
        borderW = [curBorder.borderWidth, curBorder.borderWidth, curBorder.borderWidth, curBorder.borderWidth]
      }
      let triggerType = this.animateDataVal.triggerType
      let borderColor = curBorder.borderIsThemeColor
        ? `var_BorderColor_page.themeColor`
        : curBorder.borderColor.color
        ? curBorder.borderColor.color
        : curBorder.borderColor
      this.animateDataVal.variable[`${triggerType}BorderColor`] = borderColor
      this.animateDataVal.variable[`${triggerType}BorderStyle`] = curBorder.borderStyle
      this.animateDataVal.variable[`${triggerType}BorderTopWidth`] = borderW[0] + "px"
      this.animateDataVal.variable[`${triggerType}BorderRightWidth`] = borderW[1] + "px"
      this.animateDataVal.variable[`${triggerType}BorderBottomWidth`] = borderW[2] + "px"
      this.animateDataVal.variable[`${triggerType}BorderLeftWidth`] = borderW[3] + "px"
    }
  },
  beforeDestroy() {
    // 改变颜色的时候未触发 set  所以在关闭前重新计算一次
    this.getBorderStyle()
  }
}
</script>

<style lang="scss" scoped></style>
